<template>
  <div class="app-main-content">
    <div class="details-view">
      <div class="main-content">
        <div class="tabs-container">
          <el-tabs v-model="activeTabName" type="card" style="width:100%">
            <el-tab-pane label="自定义控件" name="customComponent">
              <custom-component />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="标准控件-element" name="standardComponent">
              <standard-component />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="通知提示" name="notifyTips">
              <notify-tips />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="国际化demo" name="i18nDemo">
              <i18n-demo />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="国际化工具" name="langTools">
              <lang-tools />
            </el-tab-pane>
            <el-tab-pane :lazy="true" label="XML转JSON" name="xmlToJson">
              <xml-to-json />
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import customComponent from './components/customComponent'
import standardComponent from './components/standardComponent'
import notifyTips from './components/notifyTips'
import i18nDemo from './components/i18nDemo'
import langTools from './components/langTools'
import xmlToJson from './components/xmlToJson'

export default {
  name: 'UiDocumentIndex',
  components: { customComponent, standardComponent, notifyTips, i18nDemo, langTools, xmlToJson },
  data() {
    return {
      activeTabName: 'customComponent'
    }
  }
}
</script>
